export class GetStates {
  static readonly type = '[States] Get States'
}
